import React, { FC } from 'react'
import styled from 'styled-components'
import { IIndexEgePageProps } from '../types'
import SC from '../base/IndexEgePageFeedback.styles'
import FeedbacksBlock from '../../../../../components/Blocks/FeedbacksBlock/desktop'
import ImgTopLeft from '../assets/img__feedbacks_left_top_desktop.png'
import ImgTopRight from '../assets/img__feedbacks_right_top_desktop.png'

const { Block } = SC

const TopLeft = styled.img`
  position: absolute;
  top: -60px;
  width: 120px;
  left: 0;
  z-index: 2;
`

const TopRight = styled.img`
  position: absolute;
  top: 0;
  width: 120px;
  right: 0;
  z-index: 1;
`

const IndexEgePageFeedback: FC<IIndexEgePageProps['content']['feedback']> = (props) => {
  const { title, list } = props

  return (
    <Block id='feedbacks'>
      <FeedbacksBlock title={title || ''} list={list} />

      <TopLeft src={ImgTopLeft} />
      <TopRight src={ImgTopRight} />
    </Block>
  )
}

export default IndexEgePageFeedback
